<template>
  <div class="odmik-vsebine-nastavtive-telefonija glasovna-posta">
    <div>
      <hr class="hr-stil">
      <div class="odmik-locenih-vsebin">
        <div>
          <div>
            <p class="open-sans-20pt">
              Glasovna pošta
            </p>
          </div>
        </div>
      </div>
      <div>
        <p class="navadno-besedilo">
          <b>
            Za izbrano mobilno številko lahko nastavite eno ali več preusmeritev klicev.
          </b>
          Preusmerjeni klici se obračunavajo skladno s cenikom – kot klic iz domačega T-2 omrežja v omrežje
          preusmerjene številke. Preusmeritve na mobilni telefoniji so možne le na slovenske telefonske številke.
        </p>
      </div>
      <div v-if="podatkiGlasovnePoste !== null">
        <el-form label-width="200px" ref="glasovnaPostaForm" :model="podatkiGlasovnePoste" :rules="rules"
                 :label-position="formaOrientacija"  class="nova-vrstica-forma">
          <el-form-item label="Aktivno">
            <el-switch class="custom-disabled-switch mobile-kljukica" v-model="podatkiGlasovnePoste.active">
            </el-switch>
          </el-form-item>
          <el-form-item label="Geslo">
            <el-input
              :disabled="!podatkiGlasovnePoste.active"
              class="velikost-inptu-glasovna-posta"
              v-model="podatkiGlasovnePoste.pin"
              @input="onPinInput"
              @keydown="onPinKeydown"
              maxlength="6"
              type="tel">
            </el-input>
          </el-form-item>
          <el-form-item label="Email">
            <el-input class="velikost-inptu-glasovna-posta" v-model="podatkiGlasovnePoste.email"
                      :disabled="!podatkiGlasovnePoste.active">
            </el-input>
          </el-form-item>
          <el-form-item label="Tel. številka za SMS">
            <el-input
              class="velikost-inptu-glasovna-posta"
              v-model="smsPhoneNumberDisplay"
              :disabled="!podatkiGlasovnePoste.active"
            ></el-input>
            <span class="odmik-namiga">
              <img src="/static/img/Nastavitve/Televizija/Icon-awesome-info-circle.png"
                   class="velikost-ikone">
              <p style="display: inline-block; padding-left: 5px">
                  Številke se mora vpisati v formatu 386xxxxxxxx. <br class="nova-vrstica" />
              </p>
            </span>
          </el-form-item>
        </el-form>
        <info-komponenta-globalna
          v-if="prikaziOpozoriloZaDeaktivacijo"
          icon="fa fa-exclamation-triangle"
          icon-color="black"
          icon-size="18px"
          text-color="black"
          background-color="white"
          border="solid 1px black"
          class="mt-4 mb-4"
          font-size="13px"
        >
          Ob deaktivaciji glasovne pošte, bodo avtomatsko deaktivirane vse preusmeritve, ki trenutno kažejo na glasovno pošto!
        </info-komponenta-globalna>
        <div class="postavitev-gumb">
          <el-button type="primary" @click="SetGlasovnaPosta"
                     class="gumb-potrdi">
            SHRANI SPREMEMBE
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import InfoOknoPreusmeritve from './NastavitveMobilnaTelefonija/InfoOknoPreusmeritve.vue'
import {Button, Checkbox, Collapse, CollapseItem, Input, Loading, Select} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent'
import InfoKomponentaGlobalna from '../../../../UIComponents/InfoKomponentaGlobalna.vue'

export default {
  name: 'GlasovnaPosta',
  components: {
    InfoKomponentaGlobalna,
    InfoOknoPreusmeritve,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  props: {
    izbranaTelefonska: String,
    podatkiOSim: null,
    sap: null
  },
  data () {
    return {
      formaOrientacija: 'left',
      klicNaCakanju: '',
      casovnaIzbira: '',
      mejnaSirina: 1200,
      jePridobivanjePreusmeritevUMTS: false,
      clientAgent: null,
      seznamPreusmeritev: [],
      podatkiGlasovnePoste: null,
      rules: {
        pin: [
          {
            pattern: /^\d{4,6}$/,
            message: 'Geslo mora vsebovati 4-6 številk',
            trigger: ['blur', 'change']
          }
        ]
      },
      narocnine: null,
      defaultEmail: null,
      prikaziOpozoriloZaDeaktivacijo: false
    }
  },
  computed: {
    smsPhoneNumberDisplay: {
      get () {
        const value = this.podatkiGlasovnePoste.smsPhoneNumber
        return (value === 0 || value === '0') ? '' : value
      },
      set (newValue) {
        this.podatkiGlasovnePoste.smsPhoneNumber = newValue
      }
    }
  },
  created () {
    this.clientAgent = new ClientAgent()
  },
  async mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    if (this.sap !== null) {
      await this.loadNarocnine()
    }
    this.GetStatusGlasovnaPosta()
  },
  methods: {
    async loadNarocnine () {
      try {
        let response = await this.clientAgent.makeRequest(
          'permissions/havePermission',
          {
            permissionId: 'STRANKE'
          },
          'GET'
        )
        let narocnineTmp = {}
        if (response.permission != null && response.permission.additionalData != null) {
          response.permission.additionalData.forEach(item => {
            narocnineTmp[item.selector_id] = item
            if (item.selector_id === this.sap) {
              this.defaultEmail = item.email
            }
          })
        }
        this.narocnine = narocnineTmp
      } catch (e) {
        let errorMsg = {message: e.message}
        this.ShowWarningMessage(errorMsg)
      }
    },
    async GetStatusGlasovnaPosta () {
      try {
        if (this.podatkiOSim !== null && this.podatkiOSim.stevilka !== null) {
          this.response = await this.clientAgent.makeRequest(
            'prikljucek/telefonija/umts/vms/status',
            {
              stevilka: this.podatkiOSim.stevilka
            },
            'GET'
          )
          this.pridobivanjeGlasovnePoste(this.response)
        }
      } catch (e) {
        this.ErrPreusmeritve({message: 'Prišlo je do napake.'})
      }
    },
    pridobivanjeGlasovnePoste (podatki) {
      this.podatkiGlasovnePoste = null
      this.podatkiGlasovnePoste = podatki
      if (!podatki.active) {
        if (this.podatkiOSim !== null && this.podatkiOSim.stevilka !== null) {
          this.podatkiGlasovnePoste.smsPhoneNumber = this.podatkiOSim.stevilka
        }
        this.podatkiGlasovnePoste.email = this.defaultEmail
      }
    },
    onPinKeydown (event) {
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']

      if (allowedKeys.includes(event.key)) {
        return
      }
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault()
      }
      if (this.podatkiGlasovnePoste.pin.length >= 6) {
        event.preventDefault()
      }
    },
    onPinInput (value) {
      const cleanValue = value.replace(/[^0-9]/g, '').slice(0, 6)
      if (cleanValue !== value) {
        this.podatkiGlasovnePoste.pin = cleanValue
      }
    },
    async SetGlasovnaPosta () {
      try {
        this.$refs.glasovnaPostaForm.validate()
        if (this.podatkiGlasovnePoste.pin === '') {
          this.podatkiGlasovnePoste.pin = null
        }
        this.clientAgent.makeRequest(
          'prikljucek/telefonija/umts/vms/set',
          {
            stevilka: this.podatkiOSim.stevilka,
            active: this.podatkiGlasovnePoste.active,
            pin: this.podatkiGlasovnePoste.pin,
            email: this.podatkiGlasovnePoste.email,
            smsPhoneNumber: this.smsPhoneNumberDisplay
          },
          'GET'
        ).then((response) => {
          this.response = response
          this.UspesnoPosobljenaGlasovnaPosta(this.response)
        }).catch((e) => {
          this.ErrPreusmeritve({message: 'Prišlo je do napake pri nastavitvi glasovne pošte.'})
        })
      } catch (e) {
        this.ErrPreusmeritve({message: 'Prišlo je do napake.'})
      }
    },
    UspesnoPosobljenaGlasovnaPosta () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljena glasovna pošta.'
      this.$emit('posodobiPreusmeritve')
      this.ShowSuccessMessage(paramObvestilo)
      this.GetStatusGlasovnaPosta()
    }
  },
  watch: {
    izbranaTelefonska: function () {
      if (this.izbranaTelefonska !== null) {
        this.GetStatusGlasovnaPosta()
      }
    },
    'podatkiGlasovnePoste.active': {
      handler (newVal) {
        if (!newVal && this.$refs.glasovnaPostaForm) {
          this.$refs.glasovnaPostaForm.clearValidate()
          this.prikaziOpozoriloZaDeaktivacijo = true
        } else {
          this.prikaziOpozoriloZaDeaktivacijo = false
        }
      }
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/Telefonija/NastavitveMobilnaTelefonija/Preusmeritve.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/GlasovnaPosta.vue